export class AudioManager {
  constructor(resolver) {
    this.resolver = resolver;
    this.unlocked = false;
    this.music = new Audio();
    this.music.loop = true;
    this.music.preload = "none";
    this.currentMusic = null;
    this.settings = {
      music: true,
      sfx: true,
      voice: true,
      musicVolume: 0.35,
      sfxVolume: 0.7,
      voiceVolume: 0.7,
    };
    document.addEventListener(
      "pointerdown",
      () => {
        this.unlocked = true;
      },
      { once: true },
    );
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        this.music.pause();
      } else if (this.unlocked && this.settings.music && this.currentMusic) {
        this.music.play().catch(() => {});
      }
    });
  }
  configure(settings) {
    Object.assign(this.settings, settings);
    this.music.volume = this.settings.musicVolume;
    if (!this.settings.music) {
      this.music.pause();
    }
  }
  async playMusic(opponent) {
    const entry = this.resolver.music(opponent, this.currentMusic);
    if (!entry || !this.settings.music) {
      return;
    }
    if (entry.url !== this.currentMusic) {
      this.currentMusic = entry.url;
      this.music.src = entry.url;
    }
    if (this.unlocked) {
      await this.music.play().catch(() => {});
    }
  }
  playEvent(id) {
    if (!this.unlocked || !this.settings.sfx) {
      return;
    }
    const entry = this.resolver.manifest.assets?.[`audio/sfx/${id}/default`];
    if (!entry) {
      return;
    }
    const sound = new Audio(entry.url);
    sound.volume = this.settings.sfxVolume;
    sound.play().catch(() => {});
  }
}
